<template>
  <div class="Homepage">
    <div class="uk-container">
      <div class="yt-video">
        <iframe src="https://www.youtube-nocookie.com/embed/YE7VzlLtp-4?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=1" width="560" height="315" frameborder="0" allowfullscreen uk-responsive uk-video="automute: true"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Homepage',
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
.yt-video {
  padding-top: 40px;
  margin: 0 auto;
  width: 50%;
}
</style>